import axios from "axios";
import { encryptData } from "./EssentilaMethods/Encryption";
import { decryptData } from "./EssentilaMethods/Decryption";
import countriesData from "../Utils/countriesAdvanceData.json"

const BASE_URL_MAIN = import.meta.env.VITE_MAIN_BACKEND_URL;
const BASE_URL_ECOMMERCE = import.meta.env.VITE_ECOMMERCE_BACKEND_URL;

export type MakeRequest = {
  endpoint: string;
  payload?: any;
  method?: "GET" | "POST" | "PUT" | "DELETE";
  isEncrypted?: boolean;
  isPublic?: boolean;
  isDecrypted?: boolean;
  isFormData?: boolean;
  server?: "main" | "ecommerce";
  errorId?: string;
  currency?: string
};

const getCurrency = () => {
  const localStorageCurrency = localStorage.getItem("currency")

  if (localStorageCurrency) {
    return localStorageCurrency
  }

  const countryISO = localStorage.getItem("ip_country")
  const country = countriesData?.find(item => item.iso3 === countryISO)

  if (country) {
    localStorage.setItem("currency", country.currency)
    return country.currency
  }
}

export const makeRequest = async ({
  endpoint,
  payload = {},
  method = "GET",
  isEncrypted = false,
  isPublic = false,
  isDecrypted = true,
  isFormData = false,
  server = "ecommerce",
  currency = undefined
}: MakeRequest) => {
  try {
    let dataToSend = payload;

    if (isEncrypted) {
      dataToSend = { data: encryptData(payload) };
    }

    const headers: Record<string, string> = {};
    if (!isPublic) {
      const token = localStorage.getItem("token");
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }
      headers["source"] = "ecommerce";
    }

    headers['currency'] = currency || getCurrency()

    if (isFormData) {
      headers["Content-Type"] = "multipart/form-data";
    }

    const res = await axios({
      url: `${server === "main" ? BASE_URL_MAIN : BASE_URL_ECOMMERCE}${endpoint}`,
      method,
      headers,
      data: method === "GET" ? undefined : dataToSend,
    });

    return isDecrypted ? await decryptData(res.data.data) : res.data;
  } catch (error: any) {
    let backendErrorMessage = "";
    let backendErrorId = "";
    let decrypted

    if (error?.response?.data?.data) {
      decrypted = await decryptData(error.response.data.data);
      backendErrorMessage = decrypted?.message || "";
      backendErrorId = decrypted?.errorId || "";
      delete decrypted?.message
      delete decrypted?.errorId
    }


    console.log(error)

    throw {
      message:
        backendErrorMessage ||
        error?.response?.data?.message ||
        "We are unable to process your request at the moment. please try again later.",
      errorId: backendErrorId || error?.response?.data?.errorId || null,
      ...decrypted
    };
  }
};
